import { StyledInput } from 'components/Common/FormikInput';
import { SelectCountry } from 'components/SelectCountry/SelectCountry';
import { useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Label, Row } from 'reactstrap';
import styled from 'styled-components';
import { DangerHelpText } from 'components/HelpText';

const StyledLabel = styled(Label)`
  font-size: 14px;
  font-weight: 500;
`;

const name = 'address';

export const ClientEditAddress = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const hasError = field => {
    return !!formik.errors?.address?.[field];
  };

  const showError = field => {
    return hasError(field);
  };

  const clearError = field => {
    if (formik.errors.address?.[field]) {
      formik.setFieldError(`address.${field}`, '');
    }
  };

  const handleInputChange = (e, field) => {
    const trimmedValue = e.target.value.trimStart();
    formik.setFieldValue(`address.${field}`, trimmedValue);
    if (trimmedValue.length > 0) {
      clearError(field);
    }
  };

  return (
    <>
      <Row className="p-0 mb-4 align-items-center">
        <Col xs={3}>
          <StyledLabel className="m-0">{t('client.contactName')}</StyledLabel>
        </Col>

        <Col xs={9}>
          <StyledInput
            name={`${name}.name`}
            value={formik.values.address?.name ?? ''}
            placeholder={t('client.contactsNamePlaceholder')}
            onBlur={formik.handleBlur}
            onChange={e => handleInputChange(e, 'name')}
            invalid={hasError('name')}
          />
          {showError('name') && (
            <DangerHelpText noBackground>
              {formik.errors.address.name}
            </DangerHelpText>
          )}
        </Col>
      </Row>

      <Row className="p-0 mb-4 align-items-center">
        <Col xs={3}>
          <StyledLabel className="m-0">{t('client.country')}</StyledLabel>
        </Col>

        <Col xs={5}>
          <SelectCountry
            value={formik.values.address?.country}
            placeholder={t('client.countryPlaceholder')}
            onBlur={formik.handleBlur}
            onChange={country => {
              formik.setFieldValue(`${name}.country`, country?.value);
              if (country?.value) {
                clearError('country');
              }
            }}
            invalid={hasError('country')}
          />
          {showError('country') && (
            <DangerHelpText noBackground>
              {formik.errors.address.country}
            </DangerHelpText>
          )}
        </Col>
      </Row>

      <Row className="p-0 mb-4 align-items-center">
        <Col xs={3}>
          <StyledLabel className="m-0">{t('client.state')}</StyledLabel>
        </Col>

        <Col xs={5}>
          <StyledInput
            name={`${name}.state`}
            value={formik.values.address?.state ?? ''}
            placeholder={t('client.statePlaceholder')}
            onBlur={formik.handleBlur}
            onChange={e => handleInputChange(e, 'state')}
            invalid={hasError('state')}
          />
          {showError('state') && (
            <DangerHelpText noBackground>
              {formik.errors.address.state}
            </DangerHelpText>
          )}
        </Col>
      </Row>

      <Row className="p-0 mb-4 align-items-center">
        <Col xs={3}>
          <StyledLabel className="m-0">{t('client.zipCode')}</StyledLabel>
        </Col>

        <Col xs={5}>
          <StyledInput
            name={`${name}.postalCode`}
            value={formik.values.address?.postalCode ?? ''}
            placeholder={t('client.zipCodePlaceholder')}
            onBlur={formik.handleBlur}
            onChange={e => handleInputChange(e, 'postalCode')}
            invalid={hasError('postalCode')}
          />
          {showError('postalCode') && (
            <DangerHelpText noBackground>
              {formik.errors.address.postalCode}
            </DangerHelpText>
          )}
        </Col>
      </Row>

      <Row className="p-0 mb-4 align-items-center">
        <Col xs={3}>
          <StyledLabel className="m-0">{t('client.city')}</StyledLabel>
        </Col>

        <Col xs={9}>
          <StyledInput
            name={`${name}.city`}
            value={formik.values.address?.city ?? ''}
            placeholder={t('client.cityPlaceholder')}
            onBlur={formik.handleBlur}
            onChange={e => handleInputChange(e, 'city')}
            invalid={hasError('city')}
          />
          {showError('city') && (
            <DangerHelpText noBackground>
              {formik.errors.address.city}
            </DangerHelpText>
          )}
        </Col>
      </Row>

      <Row className="p-0 mb-4 align-items-center">
        <Col xs={3}>
          <StyledLabel className="m-0">
            {t('client.addressLineFirst')}
          </StyledLabel>
        </Col>

        <Col xs={9}>
          <StyledInput
            name={`${name}.addressLineFirst`}
            value={formik.values.address?.addressLineFirst ?? ''}
            placeholder={t('client.addressLineFirstPlaceholder')}
            onBlur={formik.handleBlur}
            onChange={e => handleInputChange(e, 'addressLineFirst')}
            invalid={hasError('addressLineFirst')}
          />
          {showError('addressLineFirst') && (
            <DangerHelpText noBackground>
              {formik.errors.address.addressLineFirst}
            </DangerHelpText>
          )}
        </Col>
      </Row>
    </>
  );
};
